// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const Literal = {
    string: (value) => {
        return {
            string: value,
            type: "string",
            _visit: function (visitor) {
                return FernIr.Literal._visit(this, visitor);
            },
        };
    },
    boolean: (value) => {
        return {
            boolean: value,
            type: "boolean",
            _visit: function (visitor) {
                return FernIr.Literal._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "string":
                return visitor.string(value.string);
            case "boolean":
                return visitor.boolean(value.boolean);
            default:
                return visitor._other(value);
        }
    },
};
